// Градусы ↔ радианы
export const degreesToRadians = (deg: number) => (Math.PI / 180) * deg;
export const radiansToDegrees = (rad: number) => (180 / Math.PI) * rad;

/** Точка на окружности радиуса r под углом aDeg (0° — вверх) */
export function polarPoint(r: number, aDeg: number): [number, number] {
  const a = degreesToRadians(aDeg - 90);
  return [r * Math.cos(a), r * Math.sin(a)];
}

/** Перевод «пиксельного» зазора по внешнему радиусу в градусы текущего масштаба */
export function gapPxToDegrees(outerRadius: number, gapPx: number): number {
  return (gapPx / outerRadius) * (180 / Math.PI);
}

/** path одного сектора (из центра) со скруглёнными внешними углами */
export function buildRoundedSectorPath(
  outerRadius: number,
  startAngle: number,
  endAngle: number,
  cornerRadiusPx: number,
): string {
  const safeR = Math.max(0, Math.min(cornerRadiusPx, outerRadius * 0.49));

  // угол, который «съедают» филеты у внешней дуги
  const filletAngle = radiansToDegrees(
    Math.asin(safeR / (outerRadius - safeR)),
  );
  const outerStart = startAngle + filletAngle;
  const outerEnd = endAngle - filletAngle;

  // точки касания филетов (радиус боковых рёбер)
  const sideRadius = Math.sqrt(
    outerRadius * outerRadius - 2 * outerRadius * safeR,
  );

  const [sx0, sy0] = polarPoint(sideRadius, startAngle);
  const [fx0, fy0] = polarPoint(outerRadius, outerStart);
  const [fx1, fy1] = polarPoint(outerRadius, outerEnd);
  const [sx1, sy1] = polarPoint(sideRadius, endAngle);

  const span = (outerEnd - outerStart + 360) % 360;
  const large = span > 180 ? 1 : 0;

  return [
    "M 0 0",
    `L ${sx0} ${sy0}`,
    `A ${safeR} ${safeR} 0 0 1 ${fx0} ${fy0}`,
    `A ${outerRadius} ${outerRadius} 0 ${large} 1 ${fx1} ${fy1}`,
    `A ${safeR} ${safeR} 0 0 1 ${sx1} ${sy1}`,
    "L 0 0",
    "Z",
  ].join(" ");
}
